/// JTF3-added-AB-22-05-12

jQuery(document).ready(function($) {
	// Hide Return To Top button at the top of the page.
	$(window).scroll(function() {
		var height = $(window).scrollTop()

		if (height > 100) {
			$('.returntotop__container').fadeIn('slow')
		} else {
			$('.returntotop__container').fadeOut()
		}
	});

	// Scroll back to top on click.
	$('.returntotop__container').click(function(event) {
		event.preventDefault()
		$('html, body').animate({
			scrollTop: 0
		}, 'fast')
		return false
	});
});
